import type { SurveyQuestion } from '../../fetchSurvey/types/survey';
import type { LogicContext } from '../types';
import { evaluateDisplayLogic } from '../evaluator/evaluateDisplayLogic';

export function resolveQuestionDisplayText(
  question: SurveyQuestion,
  context: LogicContext
): string {
  const variants = question.displayVariants;
  if (!variants?.length) {
    return question.questionText;
  }

  for (const variant of variants) {
    if (variant.displayLogic && evaluateDisplayLogic(variant.displayLogic, context)) {
      return variant.questionText;
    }
  }

  return question.questionText;
}

export function applyQuestionDisplayVariants(
  questions: SurveyQuestion[],
  context: LogicContext
): SurveyQuestion[] {
  let changed = false;

  const resolved = questions.map(question => {
    const questionText = resolveQuestionDisplayText(question, context);
    if (questionText === question.questionText) {
      return question;
    }
    changed = true;
    return { ...question, questionText };
  });

  return changed ? resolved : questions;
}
